import React, { useState } from 'react'
import { Panel, Row, Col, Input, SelectPicker } from 'rsuite'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function AuditReportSummarySearchForm({
  schema,
  loading,
  onSearch = () => {},
  ...props
}) {
  const [contractNumber, setContractNumber] = useState()
  const [projectCode, setProjectCode] = useState()
  const [projectName, setProjectName] = useState()
  const [department, setDepartment] = useState()
  const [inspectionTeam, setInspectionTeam] = useState()
  const [budgetYear, setBudgetYear] = useState(props.year ? Number(props.year) : undefined)
  const [riskType, setRiskType] = useState()
  const [projectGrade, setProjectGrade] = useState()
  const [organizationName, setOrganizationName] = useState()
  const [granteePersonName, setGranteePersonName] = useState()
  const [responsibler, setResponsibler] = useState()
  const [status, setStatus] = useState(props.status ? Number(props.status) : undefined)

  const colStyle = {
    //marginTop: '5px',
    padding: '8px',
    textAlign: 'right',
  }

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded>
        <Row>
          {schema.contractNumber && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.contractNumber.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.contractNumber.hint || schema.contractNumber.label}
                  value={contractNumber}
                  onChange={(value) => {
                    setContractNumber(value)
                  }}
                />
              </Col>
            </>
          )}
          {schema.projectCode && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.projectCode.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.projectCode.hint || schema.projectCode.label}
                  value={projectCode}
                  onChange={(value) => {
                    setProjectCode(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          {schema.projectName && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.projectName.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.projectName.hint || schema.projectName.label}
                  value={projectName}
                  onChange={(value) => {
                    setProjectName(value)
                  }}
                />
              </Col>
            </>
          )}

          {schema.inspectionTeam && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.inspectionTeam.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.inspectionTeam.hint || schema.inspectionTeam.label}
                  value={inspectionTeam}
                  onChange={(value) => {
                    setInspectionTeam(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          {schema.department && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.department.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <SelectPicker
                  // searchable={false}
                  data={schema.department.options}
                  value={department}
                  block
                  placeholder={`เลือก${schema.department.label || ''}`}
                  onChange={(value) => {
                    setDepartment(value)
                  }}
                />
              </Col>
            </>
          )}

          {schema.budgetYear && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.budgetYear.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <SelectPicker
                  searchable={false}
                  data={schema.budgetYear.options}
                  value={budgetYear}
                  block
                  placeholder={`เลือก${schema.budgetYear.label || ''}`}
                  onChange={(value) => {
                    setBudgetYear(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          {schema.riskType && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.riskType.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <SelectPicker
                  searchable={false}
                  data={schema.riskType.options}
                  value={riskType}
                  block
                  placeholder={`เลือก${schema.riskType.label || ''}`}
                  onChange={(value) => {
                    setRiskType(value)
                  }}
                />
              </Col>
            </>
          )}

          {schema.projectGrade && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.projectGrade.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <SelectPicker
                  searchable={false}
                  data={schema.projectGrade.options}
                  value={projectGrade}
                  block
                  placeholder={`เลือก${schema.projectGrade.label || ''}`}
                  onChange={(value) => {
                    setProjectGrade(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          {schema.organizationName && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.organizationName.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.organizationName.hint || schema.organizationName.label}
                  value={organizationName}
                  onChange={(value) => {
                    setOrganizationName(value)
                  }}
                />
              </Col>
            </>
          )}

          {schema.granteePersonName && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.granteePersonName.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.granteePersonName.hint || schema.granteePersonName.label}
                  value={granteePersonName}
                  onChange={(value) => {
                    setGranteePersonName(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          {schema.responsibler && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.responsibler.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.responsibler.hint || schema.responsibler.label}
                  value={responsibler}
                  onChange={(value) => {
                    setResponsibler(value)
                  }}
                />
              </Col>
            </>
          )}
          {schema.status && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.status.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <SelectPicker
                  searchable={true}
                  data={schema.status.options}
                  value={status}
                  block
                  placeholder={`เลือก${schema.status.label || ''}`}
                  onChange={(value) => {
                    setStatus(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row style={{ marginTop: 20 }}>
          {/* <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col> */}
          <Col lg={8} md={8} sm={24} xs={24}>
            <SearchButton
              disabled={loading}
              onClick={() => {
                let request = {
                  contractNo: contractNumber || '',
                  projectCode: projectCode || '',
                  projectName: projectName || '',
                  department: department || '',
                  auditTeam: inspectionTeam || '',
                  year: budgetYear || 0,
                  riskLevel: riskType || 0,
                  grade: projectGrade || 0,
                  organizationName: organizationName || '',
                  granteePersonName: granteePersonName || '',
                  responsibler: responsibler || '',
                  status: status || 0,
                }
                onSearch(request)
              }}
              style={{ marginTop: 0, marginLeft: 0 }}
            >
              ค้นหา
            </SearchButton>
            <CancelButton
              onClick={() => {
                setContractNumber('')
                setProjectCode('')
                setProjectName('')
                setDepartment('')
                setInspectionTeam('')
                setBudgetYear('')
                setRiskType('')
                setProjectGrade('')
                setOrganizationName('')
                setGranteePersonName('')
                setResponsibler('')
                onSearch({})
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
